import { render, staticRenderFns } from "./SamplesStatement.vue?vue&type=template&id=03479ebe&scoped=true"
import script from "./SamplesStatement.vue?vue&type=script&lang=js"
export * from "./SamplesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03479ebe",
  null
  
)

export default component.exports